<script>
  import { cart, stage, Stages, loadCart, user } from './storage.js';
  import { createCartRequest, createCartItem } from './requests.js';
  import Loader from '../components/Loader.svelte';
  import Cart from './Cart.svelte';
  import Form from './Form.svelte';
  import Summary from './Summary.svelte';

  // props
  export let action;
  export let url;
  export let pid;
  export let uid;

  import './styles.scss';

  const cartRequired = action.startsWith('add_');

  const createCart = async () => {
    return createCartRequest().then(response => {$cart = response.data});
  }

  if (uid) $user = {id: uid};

  let loaded = false;

  // TODO async robi wszystkie awaity w kolejnosci, nie trzeba ich chainować thenami
  (async () => {
    if (cartRequired) {
      createCartItem($cart, pid)
        .then(async response => {
          if (response.status === 404) {
            await createCart();
            return createCartItem($cart, pid);
            // get and forward errors if present
          } else {
            // forward errors if present
            console.error(response);
          }
        })
        // catch errors or load cart
        .then(() => loadCart())
        .then(() => loaded = true);
    } else {
      await loadCart();
      loaded = true;
    }
  })();

  if (!['/koszyk', '/cart'].includes(location.pathname)) {
    window.history.replaceState('', '', url);
  }

  $: notEmpty = $cart && $cart.order_items.length
</script>

<svelte:head>
  <link rel="stylesheet" href="https://unpkg.com/svelte-material-ui/bare.css" />
  <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
</svelte:head>

<div class="wrapper">
  {#if loaded}
    {#if $stage === Stages.CART}
      <div class="stage">
        <Cart />
      </div>
    {:else if $stage === Stages.FORM}
      <div class="stage">
        <Form />
      </div>
    {:else if $stage === Stages.SUMMARY}
      <div class="stage">
        <Summary />
      </div>
    {:else if $stage === Stages.PLACED}
      <div class="stage">
        <!-- <PlacedOrder /> -->
      </div>
    {:else}
      404
    {/if}
  {:else}
    <Loader />
  {/if}
</div>

<style>
  .stage {
    display: block;
    background-color: white;
  }
</style>

